// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3xh8k","title":"Header_title__2SyrL","side":"Header_side__1B1Es"};